import {DEFAULT_PAGE_SIZE, DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  pageNumber: number
  pageSize: number
  total: number
}

export class FormData implements IFormData {

  pageNumber: number
  pageSize: number
  total: number

  constructor() {
    this.pageNumber = 1;
    this.pageSize = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS;
  }

}
